import React from "react";
import "./AccountType.css";

const AccountType = () => {
    const accounts = [
        {
            type: "Standard",
            currency: "USD",
            deposit: "Depends upon payment system",
            spreads: "from 1.8 pip.",
            commission: "0$",
            maxLeverage: "1:500",
            minLotSize: "0.01",
            maxLotSize: "100",
            orderExecution: "Market"
        },
        {
            type: "Classic",
            currency: "USD",
            deposit: "Depends upon payment system",
            spreads: "from 1.5 pip.",
            commission: "0$",
            maxLeverage: "1:500",
            minLotSize: "0.01",
            maxLotSize: "100",
            orderExecution: "Market"
        },
        {
            type: "Pro",
            currency: "USD",
            deposit: "500$",
            spreads: "from 0 pip.",
            commission: "2 Side commission per std lot",
            maxLeverage: "1:500",
            minLotSize: "0.01",
            maxLotSize: "100",
            orderExecution: "Market"
        },
        {
            type: "VIP",
            currency: "USD",
            deposit: "1000$",
            spreads: "from 0 pip.",
            commission: "1 Side commission per std lot",
            maxLeverage: "1:500",
            minLotSize: "0.01",
            maxLotSize: "100",
            orderExecution: "Market",
            popular: true
        }
    ];

    return (
        <section className="trading-account-section">
            <div className="why-choose-overlay">
      <p className='section-highlight'>Trading Account</p>
      </div>
            <div className="account-container">
                <h2 className="trading-account-title">Choose Your Trading Account</h2>
                <p className="trading-account-subtitle">Start your trading journey with the right account type.</p>

                <div className="trading-account-grid">
                    {accounts.map((account, index) => (
                        <div key={index} className={`trading-account-card ${account.popular ? "trading-account-popular" : ""}`}>
                            {account.popular && <span className="trading-account-badge">Most Popular</span>}
                            <h3 className="trading-account-type">{account.type} Account</h3>
                            <ul className="trading-account-details">
                                <li><strong>Base Currency:</strong> {account.currency}</li>
                                <li><strong>Min. Deposit:</strong> <p>{account.deposit}</p> </li>
                                <li><strong>Spread From:</strong> {account.spreads}</li>
                                <li><strong>Commission:</strong> <p>{account.commission}</p></li>
                                <li><strong>Max Leverage:</strong> {account.maxLeverage}</li>
                                <li><strong>Min. Lot Size:</strong> {account.minLotSize}</li>
                                <li><strong>Max. Lot Size:</strong> {account.maxLotSize}</li>
                                <li><strong>Order Execution:</strong> {account.orderExecution}</li>
                            </ul>
                            <a href="https://panel.therisefx.com/register">
                            <button className="trading-account-choose-btn">Open Account</button>
                            </a>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default AccountType;
